import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";

import { ReactComponent as CloseFillIcon } from "../../../../../../assets/images/product/specmanager/close-fill.svg";
import { ReactComponent as InformationLineIcon } from "../../../../../../assets/images/product/specmanager/information-line.svg";
import { ReactComponent as SuccessCircleIcon } from "../../../../../../assets/images/product/specmanager/Success.svg";

import "./SaveSuccessModal.css";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {string} props.testDisplayName
 * @param {"add"|"update"} props.saveAction
 * @param {"standard_only"|"all_selected"} props.updateOperation
 * @param {number} props.affectedProductCount
 * @param {boolean} props.hadCustomInSelection Selected directory contained any product-specific (custom) specs before save
 */
export default function SaveSuccessModal({
  open,
  onClose,
  testDisplayName = "",
  saveAction = "update",
  updateOperation = "standard_only",
  affectedProductCount = 0,
  hadCustomInSelection = false,
}) {
  const title = saveAction === "add" ? "Spec Added Successfully" : "Spec Updated Successfully";
  const specPhrase = saveAction === "add" ? "The new spec for" : "The updated spec for";
  const productWord = affectedProductCount === 1 ? "product" : "products";
  const subTextAfterLink = updateOperation === "standard_only"
    ? " following the standard spec."
    : ".";

  const showUnchangedBanner = updateOperation === "standard_only" && hadCustomInSelection;

  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      width={520}
      wrapClassName="GlobalTestSpec__SaveSuccessModal"
      onCancel={onClose}
    >
      <div className="TestSpecSaveSuccessModal">
        <Button
          htmlType="button"
          className="TestSpecSaveSuccessModal__close"
          aria-label="Close"
          onClick={onClose}
        >
          <CloseFillIcon className="TestSpecSaveSuccessModal__closeIcon" aria-hidden />
        </Button>

        <div className="TestSpecSaveSuccessModal__column">
          <div className="TestSpecSaveSuccessModal__checkmarkBackground">
            <SuccessCircleIcon className="TestSpecSaveSuccessModal__checkmarkIcon" aria-hidden />
          </div>

          <div className="TestSpecSaveSuccessModal__textStack">
            <h2 className="TestSpecSaveSuccessModal__title">{title}</h2>
            <p className="TestSpecSaveSuccessModal__sub">
              {specPhrase}
              {" "}
              <span className="TestSpecSaveSuccessModal__testName">{testDisplayName}</span>
              {" "}
              has been applied to
              {" "}
              <span className="TestSpecSaveSuccessModal__productEmphasis">
                {affectedProductCount}
                {" "}
                {productWord}
              </span>
              {subTextAfterLink}
            </p>
          </div>

          {showUnchangedBanner && (
            <div className="TestSpecSaveSuccessModal__banner">
              <InformationLineIcon className="TestSpecSaveSuccessModal__bannerIcon" aria-hidden />
              <p className="TestSpecSaveSuccessModal__bannerText">
                Products with product-specific limits remain unchanged.
              </p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
